import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import 'moment-timezone';

import CalendarWeekView from 'components/layout/calendar/CalendarWeekView';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class Calendar extends React.Component {
  constructor(props) {
    super(props);

    moment.locale(globalLocale);

    this.state = {
      date: moment(),
    };
  }

  navToday = () => {
    this.setState({ date: moment() });
  };

  navLeft = () => {
    // let date = moment(this.state.date).subtract(1, this.state.view + 's')
    const { date: prevDate } = this.state;
    const date = moment(prevDate).subtract(1, 'days');
    this.setState({ date });
  };

  navRight = () => {
    // let date = moment(this.state.date).add(1, this.state.view + 's')
    const { date: prevDate } = this.state;
    const date = moment(prevDate).add(1, 'days');
    this.setState({ date });
  };

  navDay = (e, day) => {
    e.preventDefault();
    e.stopPropagation();

    const { date: prevDate } = this.state;
    const date = moment(prevDate).date(day);
    this.setState({ date });
  };

  navMonth = (e, month) => {
    e.preventDefault();
    e.stopPropagation();

    const { date: prevDate } = this.state;
    const date = moment(prevDate).month(month);
    this.setState({ date });
  };

  navYear = year => {
    const { date: prevDate } = this.state;
    const date = moment(prevDate).year(year);
    this.setState({ date });
  };

  getAppts = date => {
    const { data } = this.props;

    if (!data.isLoading && data.data.list !== undefined) {
      const apptsList = data.data.list;

      const month = moment(date).format('MM');
      const day = moment(date).date();

      if (apptsList[month] !== undefined && apptsList[month][day] !== undefined) {
        return apptsList[month][day];
      }
    }

    return [];
  };

  printWeeks = () => {
    const { date } = this.state;

    const currentLocaleData = moment.localeData();

    const currentDay = moment(date).date();
    const monthStartsWith = moment(date)
      .date(1)
      .day();
    const daysInMonth = moment(date).daysInMonth();

    let weekActive = false;
    const weeks = [];
    let week = [];
    for (let i = 0; i < daysInMonth; i++) {
      const weekDay = (monthStartsWith + i) % 7;

      if (weekDay === currentLocaleData._week.dow && week.length > 0) {
        weeks.push(
          <div class={'week ' + (weekActive ? 'active current-date ' : '')} key={i}>
            {week}
          </div>
        );
        week = [];
        weekActive = false;
      }

      if (currentDay === i + 1) {
        weekActive = true;
      }

      week.push(
        <div class="day-wrapper date-selector" key={i}>
          <div class="week-day">
            <div class="day week-header">{currentLocaleData._weekdaysMin[weekDay]}</div>
          </div>
          <div class={'week-date ' + (currentDay === i + 1 ? 'active current-date ' : '')}>
            <div class="day">
              <a class={this.dayHasEvent(i + 1) ? 'has-event' : ''} href="#day" onClick={e => this.navDay(e, i + 1)}>
                {i + 1}
              </a>
            </div>
          </div>
        </div>
      );
    }

    if (week.length > 0) {
      weeks.push(
        <div class={'week ' + (weekActive ? 'active current-date ' : '')} key="a">
          {week}
        </div>
      );
    }

    return weeks;
  };

  dayHasEvent = day => {
    const { date } = this.state;

    const appts = this.getAppts(
      moment(date)
        .clone()
        .date(day)
    );

    return !!appts.length;
  };

  render() {
    const {
      intl: { messages },
      data,
    } = this.props;
    const { date } = this.state;

    const head = moment(date).format('dddd, D MMMM YYYY');

    return (
      <DocMeta tags={generateMetaTags(messages.meta.calendar)}>
        <div id="myCalendar" class="full-height bg-white">
          <div class="calendar week">
            <div class="options">
              <div class="scroll-wrapper months-drager drager relative">
                <Scrollbars autoHeight autoHide>
                  <div>
                    <div class="months" id="months">
                      {moment.monthsShort().map((month, i) => {
                        return (
                          <div class="month" key={month}>
                            <a
                              href="#month"
                              class={
                                'month-selector ' +
                                (moment(this.state.date).format('M') == i + 1 ? 'active has-event ' : '')
                              }
                              onClick={e => this.navMonth(e, i)}
                            >
                              {month}
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Scrollbars>
              </div>

              <h4 class="semi-bold date" id="currentDate">
                {head} {data.isLoading ? <i class="fa fa-circle-notch fa-spin fa-fw" /> : null}
              </h4>

              <div class="week-dragger">
                <div class="week-dragger">
                  <div class="weeks-wrapper relative">
                    <Scrollbars autoHeight autoHide>
                      {this.printWeeks()}
                    </Scrollbars>
                  </div>
                </div>
              </div>
            </div>

            <CalendarWeekView date={date} getAppts={this.getAppts} />
          </div>
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.calendar,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Calendar)));
